import messages from './en';

export default messages;
